import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import ProformaPreview from './ProformaPreview';
import EditIcon from './assets/images/edit-icon.svg';
import DeleteIcon from './assets/images/delete-icon.svg';
import PlusIcon from './assets/images/plus-icon.svg';
import { ayniUrunSor } from './AyniUrunSorusu';
import WhatsappIcon from './assets/images/whatsapp_icon.svg';
import SendFlatIcon from './assets/images/send_flat_icon.svg';
import NewOrderIcon from './assets/images/new_order_icon.svg';
import TickIcon from './assets/images/tick_icon.svg';
import CrossIcon from './assets/images/cross_icon.svg';
import * as htmlToImage from 'html-to-image';
import AltSiparisFaturalama from './AltSiparisFaturalama';

// Ortak stil tanımları — SiparisGirisFormu ile birebir eşdeğer
const baseButtonStyle = {
    width: '35px', height: '35px', fontSize: '20px', fontWeight: '600',
    color: 'white', border: '2px solid transparent', borderRadius: '5px',
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
    transition: 'opacity 0.2s ease-in-out'
};
const sourceStyles = {
    W: { backgroundColor: '#26D367' },
    S: { backgroundColor: '#3783c2' },
    R: { backgroundColor: '#f4bf4a' }
};
const paymentStyles = {
    K: { backgroundColor: '#17bebb' },
    E: { backgroundColor: '#6761a8' },
    O: { backgroundColor: '#2c6184' },
    D: { backgroundColor: '#bb999c' },
    B: { backgroundColor: '#a32e68' }
};
const tableCellStyle = {
    borderBottom: '1px solid #e2e2e2', padding: '12px 8px', verticalAlign: 'middle'
};
const kaynakRenkleri = { W: '#26D367', S: '#3783c2', R: '#f4bf4a' };
const odemeRenkleri = { K: '#17bebb', E: '#6761a8', O: '#2c6184', D: '#bb999c', B: '#a32e68' };

const rowBtnStyle = {
    width: '85px', height: '25px', background: '#F8F8F8',
    borderRadius: '6px', border: '0.50px solid black',
    cursor: 'pointer', fontSize: '12px', fontWeight: '500', fontFamily: 'Poppins, sans-serif'
};
const saveBtnStyle = {
    width: '110px', height: '37px', background: '#F8F8F8',
    borderRadius: '8px', border: '0.50px solid black',
    cursor: 'pointer', fontSize: '14px', fontWeight: '500', fontFamily: 'Poppins, sans-serif'
};

// Klavye gezinmesi (SiparisGirisFormu ile aynı): data-nav-id ile işaretli alana odaklanır
const navAlaninaGec = (navId) => {
    const el = navId && document.querySelector(`[data-nav-id="${navId}"]`);
    if (!el) return false;
    el.focus();
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    return true;
};

// Ok tuşlarıyla seçilen liste öğesi görünür alanda tutulur
const useSeciliOgeyiGoster = (seciliIndex, liste, ozellik) => {
    useEffect(() => {
        if (seciliIndex < 0 || liste.length === 0) return;
        const el = document.querySelector(`[${ozellik}="${seciliIndex}"]`);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }, [seciliIndex, liste, ozellik]);
};

/* ===========================
   ANA SIPARIS MODALI
   Layout: SiparisGirisFormu ile birebir esit (urun/finansal kismi olmayan)
   =========================== */
function AnaSimarisModal({ onClose, onKaydet, editingData }) {
    const [telefon, setTelefon] = useState(editingData?.musteri?.telefon_numarasi || '');
    const [musteriAramaSonuclari, setMusteriAramaSonuclari] = useState([]);
    const [selectedMusteriIndex, setSelectedMusteriIndex] = useState(-1);
    const [seciliMusteri, setSeciliMusteri] = useState(editingData?.musteri || null);
    const [siparis_kaynagi, setSiparisKaynagi] = useState(editingData?.siparis_kaynagi || 'W');
    const [odeme_yontemi, setOdemeYontemi] = useState(editingData?.odeme_yontemi || 'K');
    const [formModu, setFormModu] = useState('gosterim');
    const [adresFormData, setAdresFormData] = useState({ id: null, ad_soyad: '', telefon_numarasi: '', adres: '', il: '', ilce: '' });
    const [ilIlceListesi, setIlIlceListesi] = useState({ iller: [], ilceler: [] });

    useEffect(() => {
        fetch('api/konum/iller', {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        }).then(r => r.json()).then(data => setIlIlceListesi(prev => ({ ...prev, iller: data })));
    }, []);

    useEffect(() => {
        const aktifIl = formModu !== 'gosterim' ? adresFormData.il : seciliMusteri?.il;
        if (aktifIl) {
            fetch(`api/konum/ilceler/${aktifIl}`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            }).then(r => r.json()).then(data => setIlIlceListesi(prev => ({ ...prev, ilceler: data })));
        } else {
            setIlIlceListesi(prev => ({ ...prev, ilceler: [] }));
        }
    }, [seciliMusteri, adresFormData.il, formModu]);

    useEffect(() => {
        if (telefon.length < 10) { setSeciliMusteri(null); setMusteriAramaSonuclari([]); return; }
        const timer = setTimeout(() => {
            fetch(`api/musteriler/telefon/${telefon}`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            }).then(r => r.json()).then(data => {
                if (data.length === 0) {
                    setSeciliMusteri({ id: null, ad_soyad: `xxxx${telefon.slice(-4)}` });
                    setMusteriAramaSonuclari([]);
                } else if (data.length === 1) {
                    setSeciliMusteri(data[0]);
                    setMusteriAramaSonuclari([]);
                } else {
                    setMusteriAramaSonuclari(data);
                    setSeciliMusteri(null);
                }
            });
        }, 500);
        return () => clearTimeout(timer);
    }, [telefon]);

    useEffect(() => { setSelectedMusteriIndex(-1); }, [musteriAramaSonuclari]);
    useSeciliOgeyiGoster(selectedMusteriIndex, musteriAramaSonuclari, 'data-musteri-index');

    const handleMusteriAramaKeyDown = (e) => {
        if (musteriAramaSonuclari.length === 0) {
            // Liste kapalıyken aşağı ok: adres formu açıksa ilk alana geç
            if (e.key === 'ArrowDown' && formModu !== 'gosterim') { e.preventDefault(); navAlaninaGec('ana-ad-soyad-input'); }
            return;
        }
        if (e.key === 'ArrowDown') { e.preventDefault(); setSelectedMusteriIndex(prev => prev < musteriAramaSonuclari.length - 1 ? prev + 1 : 0); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setSelectedMusteriIndex(prev => prev > 0 ? prev - 1 : musteriAramaSonuclari.length - 1); }
        else if (e.key === 'Enter') { e.preventDefault(); if (selectedMusteriIndex >= 0) handleMusteriSecimi(musteriAramaSonuclari[selectedMusteriIndex]); }
        else if (e.key === 'Escape') { e.preventDefault(); setMusteriAramaSonuclari([]); setSelectedMusteriIndex(-1); }
    };

    // Adres formu alanları arasında yukarı/aşağı okla gezinme (sağ/sol metin içinde imleci gezdirir)
    const ADRES_ALANLARI = ['ana-telefon-input', 'ana-ad-soyad-input', 'ana-adres-input', 'ana-il-select', 'ana-ilce-select'];
    const handleAdresAlaniKeyDown = (e, navId) => {
        if (formModu === 'gosterim' || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
        // Çok satırlı adres alanında ok tuşu önce satırlar arasında gezer; ilk/son satırdayken alan değiştirir
        if (e.target.tagName === 'TEXTAREA') {
            const { selectionStart, value } = e.target;
            if (e.key === 'ArrowUp' && value.lastIndexOf('\n', selectionStart - 1) !== -1) return;
            if (e.key === 'ArrowDown' && value.indexOf('\n', selectionStart) !== -1) return;
        }
        e.preventDefault();
        const i = ADRES_ALANLARI.indexOf(navId);
        navAlaninaGec(ADRES_ALANLARI[e.key === 'ArrowDown' ? i + 1 : i - 1]);
    };

    const handleMusteriSecimi = (musteri) => { setSeciliMusteri(musteri); setMusteriAramaSonuclari([]); setSelectedMusteriIndex(-1); };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setAdresFormData(prev => { const ns = { ...prev, [name]: value }; if (name === 'il') ns.ilce = ''; return ns; });
    };

    const handleDuzenleClick = () => { setAdresFormData({ ...seciliMusteri }); setFormModu('duzenleme'); };
    const handleYeniKayitClick = () => { setAdresFormData({ id: null, ad_soyad: '', telefon_numarasi: telefon, adres: '', il: '', ilce: '' }); setFormModu('yeniKayit'); };
    const handleFormIptal = () => { setFormModu('gosterim'); };

    const handleMusteriKaydet = () => {
        const token = localStorage.getItem('token');
        const endpoint = formModu === 'duzenleme' ? `api/musteriler/${adresFormData.id}` : 'api/musteriler';
        const method = formModu === 'duzenleme' ? 'PUT' : 'POST';
        fetch(endpoint, { method, headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(adresFormData) })
            .then(r => r.json()).then(data => { if (data.hata) return alert(data.hata); setSeciliMusteri(data.musteri); setFormModu('gosterim'); });
    };

    const handleKaydet = () => {
        if (!seciliMusteri) return alert('Lütfen bir müşteri seçin veya telefon numarası girin.');
        onKaydet({ musteri: seciliMusteri, telefon, siparis_kaynagi, odeme_yontemi });
        onClose();
    };

    const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '8px', marginBottom: '12px', fontFamily: 'Poppins, sans-serif', border: '1px solid #ccc', borderRadius: '4px' };
    const disabledInput = { ...inputStyle, background: '#E2E2E2' };

    return (
        <div style={{ maxWidth: '834px', background: '#F2F2F2', boxShadow: '0px 4px 4px rgba(0,0,0,0.25)', borderRadius: '8px', padding: '20px', fontFamily: 'Poppins, sans-serif' }}>

            {/* UST KONTROL PANELI */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', paddingBottom: '15px', borderBottom: '1px solid #eee' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <strong style={{ fontWeight: '500' }}>Sipariş Kaynağı</strong>
                    {['W', 'S', 'R'].map(k => (
                        <button key={k} type="button" onClick={() => setSiparisKaynagi(k)}
                            style={{ ...baseButtonStyle, ...sourceStyles[k], opacity: siparis_kaynagi === k ? 1 : 0.25 }}>
                            {k}
                        </button>
                    ))}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <strong style={{ fontWeight: '500' }}>Ödeme Yöntemi</strong>
                    {['K', 'E', 'O', 'D', 'B'].map(o => (
                        <button key={o} type="button" onClick={() => setOdemeYontemi(o)}
                            style={{ ...baseButtonStyle, ...paymentStyles[o], opacity: odeme_yontemi === o ? 1 : 0.25 }}>
                            {o}
                        </button>
                    ))}
                </div>
            </div>

            {/* ANA GOVDE */}
            <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', background: '#F8F8F8', border: '1px solid #C2C2C2', padding: '15px', borderRadius: '5px' }}>

                {/* SOL TARAF */}
                <div style={{ flex: 2, background: '#F8F8F8', border: '1px solid #C2C2C2', padding: '15px', borderRadius: '5px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                        <label style={{ fontWeight: '500' }}>Telefon:</label>
                        <input type="text" placeholder="Numara Giriniz..." value={telefon} data-nav-id="ana-telefon-input"
                            onChange={e => setTelefon(e.target.value)} onKeyDown={handleMusteriAramaKeyDown} autoFocus
                            style={{ width: '140px', height: '27px', background: '#FFFFFF', border: '1px solid #ccc', borderRadius: '4px', padding: '5px 10px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }}
                        />
                        {formModu === 'gosterim' && seciliMusteri && (
                            seciliMusteri.id ? (
                                <>
                                    <button type="button" onClick={handleYeniKayitClick} style={rowBtnStyle}>Yeni Kayıt</button>
                                    <button type="button" onClick={handleDuzenleClick} style={rowBtnStyle}>Düzenle</button>
                                </>
                            ) : (
                                <button type="button" onClick={handleYeniKayitClick} style={rowBtnStyle}>Yeni Kayıt</button>
                            )
                        )}
                        {(formModu === 'duzenleme' || formModu === 'yeniKayit') && (
                            <>
                                <button type="button" onClick={handleMusteriKaydet} style={{ ...rowBtnStyle, width: '90px', background: '#d8f8aeff' }}>Kaydet</button>
                                <button type="button" onClick={handleFormIptal} style={{ ...rowBtnStyle, width: '90px', background: '#fae1c1ff' }}>Vazgeç</button>
                            </>
                        )}
                    </div>

                    {musteriAramaSonuclari.length > 1 && (
                        <div style={{ border: '1px solid #000', background: '#fff', borderRadius: '4px', marginBottom: '10px', padding: '10px' }}>
                            <h5 style={{ margin: '0 0 10px 0', paddingBottom: '5px', borderBottom: '1px solid #ccc', fontWeight: '500' }}>Adres Seçiniz:</h5>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, maxHeight: '250px', overflowY: 'auto' }}>
                                {musteriAramaSonuclari.map((m, idx) => (
                                    <li key={m.id} data-musteri-index={idx} onClick={() => handleMusteriSecimi(m)}
                                        style={{ cursor: 'pointer', padding: '12px 8px', borderRadius: '3px', background: idx === selectedMusteriIndex ? '#e3f2fd' : (m.is_last_used ? '#e8f5e9' : 'transparent'), borderBottom: '1px solid #eee', fontWeight: idx === selectedMusteriIndex ? '600' : 'normal' }}
                                        onMouseEnter={e => { if (idx !== selectedMusteriIndex) e.currentTarget.style.backgroundColor = '#d1e7fd'; }}
                                        onMouseLeave={e => { if (idx !== selectedMusteriIndex) e.currentTarget.style.backgroundColor = m.is_last_used ? '#e8f5e9' : 'transparent'; }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            <div>
                                                <strong style={{ fontSize: '14px' }}>{m.ad_soyad}</strong>
                                                <div style={{ fontSize: '13px', color: '#555', marginTop: '4px' }}>{m.adres}</div>
                                                <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>{`${m.ilce || ''}, ${(m.il || '').toUpperCase()}`}</div>
                                            </div>
                                            {m.is_last_used && <span style={{ color: '#2e7d32', fontWeight: 'bold', fontSize: '12px', background: '#c8e6c9', padding: '2px 8px', borderRadius: '10px', flexShrink: 0, marginLeft: '10px' }}>Son Adres</span>}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <div style={{ borderTop: '0.5px solid #ddd', marginTop: '10px', paddingTop: '10px' }}>
                        <input type="text" name="ad_soyad" placeholder="Adi Soyadi" disabled={formModu === 'gosterim'}
                            data-nav-id="ana-ad-soyad-input" onKeyDown={e => handleAdresAlaniKeyDown(e, 'ana-ad-soyad-input')}
                            value={formModu !== 'gosterim' ? adresFormData.ad_soyad : (seciliMusteri?.ad_soyad || '')}
                            onChange={handleFormChange} style={formModu === 'gosterim' ? disabledInput : inputStyle}
                        />
                        <textarea name="adres" placeholder="Adres Bilgisi" rows="3" disabled={formModu === 'gosterim'}
                            data-nav-id="ana-adres-input" onKeyDown={e => handleAdresAlaniKeyDown(e, 'ana-adres-input')}
                            value={formModu !== 'gosterim' ? adresFormData.adres : (seciliMusteri?.adres || '')}
                            onChange={handleFormChange}
                            style={{ ...inputStyle, background: formModu === 'gosterim' ? '#E2E2E2' : 'white', resize: 'none' }}
                        />
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <select name="il" disabled={formModu === 'gosterim'}
                                data-nav-id="ana-il-select" onKeyDown={e => handleAdresAlaniKeyDown(e, 'ana-il-select')}
                                value={formModu !== 'gosterim' ? adresFormData.il : (seciliMusteri?.il || '')}
                                onChange={handleFormChange}
                                style={{ flex: 1, padding: '8px', fontFamily: 'Poppins, sans-serif', background: formModu === 'gosterim' ? '#E2E2E2' : 'white', border: '1px solid #ccc', borderRadius: '4px' }}>
                                <option value="">İl Seçiniz</option>
                                {ilIlceListesi.iller.map(il => <option key={il} value={il}>{il}</option>)}
                            </select>
                            <select name="ilce" disabled={formModu === 'gosterim'}
                                data-nav-id="ana-ilce-select" onKeyDown={e => handleAdresAlaniKeyDown(e, 'ana-ilce-select')}
                                value={formModu !== 'gosterim' ? adresFormData.ilce : (seciliMusteri?.ilce || '')}
                                onChange={handleFormChange}
                                style={{ flex: 1, padding: '8px', fontFamily: 'Poppins, sans-serif', background: formModu === 'gosterim' ? '#E2E2E2' : 'white', border: '1px solid #ccc', borderRadius: '4px' }}>
                                <option value="">İlçe Seçiniz</option>
                                {ilIlceListesi.ilceler.map(ilce => <option key={ilce} value={ilce}>{ilce}</option>)}
                            </select>
                        </div>
                    </div>
                </div>

                {/* SAG TARAF */}
                <div style={{ flex: 1, background: '#F8F8F8', border: '1px solid #C2C2C2', padding: '15px', borderRadius: '5px', minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <p style={{ color: '#bbb', fontSize: '13px', textAlign: 'center', margin: 0 }}>
                        Ürünler alt siparişlerden girilir.
                    </p>
                </div>
            </div>

            <div style={{ marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '15px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button type="button" onClick={onClose} style={saveBtnStyle}>Vazgeç</button>
                <button type="button" onClick={handleKaydet} style={saveBtnStyle}>{editingData ? 'Güncelle' : 'Kaydet'}</button>
            </div>
        </div>
    );
}

/* ===========================
   ALT SIPARIS MODALI
   Sol = ayirici isim, Sag = makine baskilari (dikey)
   Urun girisi: SiparisGirisFormu ile birebir esit
   =========================== */
function AltSiparisModal({ anaMusteri, onClose, onKaydet, editingData }) {
    const [nickname, setNickname] = useState(editingData?.nickname || '');
    const [sepet, setSepet] = useState(editingData?.sepet || []);
    const [urunAramaTerimi, setUrunAramaTerimi] = useState('');
    const [urunAramaSonuclari, setUrunAramaSonuclari] = useState([]);
    const [selectedUrunIndex, setSelectedUrunIndex] = useState(-1);
    const [aktifUrun, setAktifUrun] = useState(null);
    const [aktifUrunAdet, setAktifUrunAdet] = useState('');
    const [makineBaskilari, setMakineBaskilari] = useState([]);
    const [makineAdetleri, setMakineAdetleri] = useState(editingData?.makine_adetleri || {});
    const [editingCell, setEditingCell] = useState(null);

    useEffect(() => {
        fetch('api/urunler/makine-baskisi', {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        }).then(r => r.json()).then(setMakineBaskilari);
    }, []);

    useEffect(() => {
        if (aktifUrun && urunAramaTerimi === aktifUrun.urun_adi) return;
        if (urunAramaTerimi.length < 2) { setUrunAramaSonuclari([]); return; }
        const timer = setTimeout(() => {
            fetch(`api/urunler/arama/${urunAramaTerimi}`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            }).then(r => r.json()).then(setUrunAramaSonuclari);
        }, 300);
        return () => clearTimeout(timer);
    }, [urunAramaTerimi, aktifUrun]);

    useEffect(() => { setSelectedUrunIndex(-1); }, [urunAramaSonuclari]);
    useSeciliOgeyiGoster(selectedUrunIndex, urunAramaSonuclari, 'data-urun-index');

    // Alan sırası: ayırıcı isim → makine baskıları → ürün arama → adet
    const sonMakineNavId = () => makineBaskilari.length ? `alt-makine-${makineBaskilari[makineBaskilari.length - 1].id}` : 'alt-nickname-input';
    const ilkMakineNavId = () => makineBaskilari.length ? `alt-makine-${makineBaskilari[0].id}` : 'alt-urun-arama-input';

    const handleNicknameKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'ArrowDown') { e.preventDefault(); navAlaninaGec(ilkMakineNavId()); }
    };

    const handleUrunAramaKeyDown = (e) => {
        if (urunAramaSonuclari.length === 0) {
            // Liste kapalıyken Enter: ürün seçiliyse adet alanına git
            if ((e.key === 'Enter' && aktifUrun) || e.key === 'ArrowDown') {
                e.preventDefault();
                navAlaninaGec('alt-urun-adet-input');
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                navAlaninaGec(sonMakineNavId());
            }
            return;
        }
        if (e.key === 'ArrowDown') { e.preventDefault(); e.stopPropagation(); setSelectedUrunIndex(prev => prev < urunAramaSonuclari.length - 1 ? prev + 1 : 0); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopPropagation(); setSelectedUrunIndex(prev => prev > 0 ? prev - 1 : urunAramaSonuclari.length - 1); }
        else if (e.key === 'Enter') {
            e.preventDefault(); e.stopPropagation();
            if (selectedUrunIndex >= 0) {
                const u = urunAramaSonuclari[selectedUrunIndex];
                setAktifUrun(u); setUrunAramaTerimi(u.urun_adi); setUrunAramaSonuclari([]); setSelectedUrunIndex(-1);
                setTimeout(() => { const el = document.querySelector('[data-nav-id="alt-urun-adet-input"]'); if (el) el.focus(); }, 80);
            }
        } else if (e.key === 'Escape') { e.stopPropagation(); setUrunAramaSonuclari([]); setSelectedUrunIndex(-1); }
    };

    const handleMakineKeyDown = (e, currentIndex) => {
        if (e.key === 'Enter' || e.key === 'ArrowDown') {
            e.preventDefault();
            const nextIndex = currentIndex + 1;
            if (nextIndex < makineBaskilari.length) {
                const nextInput = document.querySelector(`[data-nav-id="alt-makine-${makineBaskilari[nextIndex].id}"]`);
                if (nextInput) nextInput.focus();
            } else {
                const urunArama = document.querySelector('[data-nav-id="alt-urun-arama-input"]');
                if (urunArama) urunArama.focus();
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevIndex = currentIndex - 1;
            navAlaninaGec(prevIndex >= 0 ? `alt-makine-${makineBaskilari[prevIndex].id}` : 'alt-nickname-input');
        }
    };

    const handleMakineAdetChange = (urunId, adet) => {
        const sayisalAdet = Math.max(0, parseInt(adet) || 0);
        const urun = makineBaskilari.find(u => u.id === urunId);
        if (!urun) return;
        setMakineAdetleri(prev => ({ ...prev, [urunId]: sayisalAdet }));
        setSepet(mevcutSepet => {
            const idx = mevcutSepet.findIndex(item => item.id === urunId && item.isMakine);
            if (sayisalAdet === 0) return idx > -1 ? mevcutSepet.filter((_, i) => i !== idx) : mevcutSepet;
            const guncel = { ...urun, adet: sayisalAdet, isMakine: true };
            if (idx > -1) { const ns = [...mevcutSepet]; ns[idx] = guncel; return ns; }
            return [...mevcutSepet, guncel];
        });
    };

    const handleSepeteEkle = async () => {
        if (!aktifUrun || !aktifUrunAdet || aktifUrunAdet <= 0) return alert('Lütfen ürün ve adet seçin.');
        // Ürün sepette zaten varsa: ayrı kalem (farklı fiyat verilebilsin) ya da mevcut kaleme ekle
        let ayriKalem = false;
        if (sepet.some(u => u.id === aktifUrun.id && !u.isMakine)) {
            const secim = await ayniUrunSor(aktifUrun.urun_adi);
            if (!secim) return; // Vazgeçildi: alanlar korunur
            ayriKalem = secim === 'yeni';
        }
        setSepet(mevcutSepet => {
            const idx = ayriKalem ? -1 : mevcutSepet.findIndex(u => u.id === aktifUrun.id && !u.isMakine);
            if (idx > -1) { const ns = [...mevcutSepet]; ns[idx] = { ...ns[idx], adet: ns[idx].adet + parseInt(aktifUrunAdet) }; return ns; }
            return [...mevcutSepet, { ...aktifUrun, adet: parseInt(aktifUrunAdet), isMakine: false }];
        });
        setAktifUrun(null); setUrunAramaTerimi(''); setAktifUrunAdet('');
        setTimeout(() => { const el = document.querySelector('[data-nav-id="alt-urun-arama-input"]'); if (el) el.focus(); }, 100);
    };

    const handleSepetChange = (index, field, value) => { const ns = [...sepet]; ns[index][field] = parseFloat(value) || 0; setSepet(ns); };

    // Aynı ürün ayrı kalemlerde olabileceği için silme satır index'i ile yapılır
    const handleSepetUrunSil = (index) => {
        const silinen = sepet[index];
        if (!silinen) return;
        if (silinen.isMakine) { handleMakineAdetChange(silinen.id, 0); }
        else { setSepet(s => s.filter((_, i) => i !== index)); }
    };

    const genelToplam = sepet.reduce((acc, u) => acc + ((u.fiyat || 0) * (u.adet || 0)), 0);

    const handleKaydet = () => {
        if (!nickname.trim()) return alert('Lütfen bir ayırıcı isim girin.');
        if (sepet.length === 0) return alert('Lütfen en az bir ürün ekleyin.');
        onKaydet({ nickname, sepet, makine_adetleri: makineAdetleri, toplam_bedel: genelToplam });
        onClose();
    };

    return (
        <div style={{ maxWidth: '834px', background: '#F2F2F2', boxShadow: '0px 4px 4px rgba(0,0,0,0.25)', borderRadius: '8px', padding: '20px', fontFamily: 'Poppins, sans-serif' }}>

            {/* ANA GOVDE */}
            <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', background: '#F8F8F8', border: '1px solid #C2C2C2', padding: '15px', borderRadius: '5px' }}>

                {/* SOL TARAF - Ayirici Isim */}
                <div style={{ flex: 2, background: '#F8F8F8', border: '1px solid #C2C2C2', padding: '15px', borderRadius: '5px' }}>
                    {anaMusteri && (
                        <div style={{ marginBottom: '12px', fontSize: '13px', color: '#555' }}>
                            <strong>Ana Sipariş:</strong> {anaMusteri.ad_soyad} / {anaMusteri.telefon_numarasi}
                        </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingTop: anaMusteri ? '0' : '0' }}>
                        <label style={{ fontWeight: '500', whiteSpace: 'nowrap' }}>Ayırıcı İsim:</label>
                        <input type="text" placeholder="Örnek: Anne, Eş, Ofis..."
                            value={nickname} onChange={e => setNickname(e.target.value)} autoFocus
                            data-nav-id="alt-nickname-input" onKeyDown={handleNicknameKeyDown}
                            style={{ width: '200px', height: '27px', background: '#FFFFFF', border: '1px solid #ccc', borderRadius: '4px', padding: '5px 10px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }}
                        />
                    </div>
                </div>

                {/* SAG TARAF - Makine Baskilari (dikey) */}
                <div style={{ flex: 1, background: '#F8F8F8', border: '1px solid #C2C2C2', padding: '15px', borderRadius: '5px' }}>
                    {makineBaskilari.length === 0 ? (
                        <p style={{ color: '#bbb', fontSize: '12px', margin: 0, textAlign: 'center' }}>Yukleniyor...</p>
                    ) : (
                        makineBaskilari.map((urun) => (
                            <div key={urun.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                <label style={{ fontSize: '13px' }}>{urun.urun_adi}:</label>
                                <input type="number" min="0" value={makineAdetleri[urun.id] || ''}
                                    data-nav-id={`alt-makine-${urun.id}`}
                                    onChange={e => handleMakineAdetChange(urun.id, e.target.value)}
                                    onKeyDown={e => handleMakineKeyDown(e, makineBaskilari.indexOf(urun))}
                                    style={{ width: '70px', height: '27px', background: 'white', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'center', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }}
                                />
                            </div>
                        ))
                    )}
                </div>
            </div>

            <div style={{ height: '5px' }} />

            {/* URUN GIRIS BARI */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', background: '#F8F8F8', border: '1px solid #C2C2C2', padding: '8px 15px', borderRadius: '5px' }}>
                <label style={{ fontWeight: '500' }}>Ürün Giriniz</label>
                <div style={{ position: 'relative', flex: 1 }}>
                    <input type="text" placeholder="Ürün adı veya kodu..."
                        data-nav-id="alt-urun-arama-input" value={urunAramaTerimi}
                        onChange={e => { setUrunAramaTerimi(e.target.value); if (e.target.value !== aktifUrun?.urun_adi) setAktifUrun(null); }}
                        onKeyDown={handleUrunAramaKeyDown}
                        style={{ width: '480px', height: '30px', background: 'white', border: '1px solid #ccc', borderRadius: '4px', padding: '5px 10px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }}
                    />
                    {urunAramaSonuclari.length > 0 && (
                        <ul style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', listStyle: 'none', padding: 0, margin: '2px 0 0 0', zIndex: 100, borderRadius: '4px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', maxHeight: '200px', overflowY: 'auto' }}>
                            {urunAramaSonuclari.map((urun, idx) => (
                                <li key={urun.id} data-urun-index={idx}
                                    onClick={() => { setAktifUrun(urun); setUrunAramaTerimi(urun.urun_adi); setUrunAramaSonuclari([]); setSelectedUrunIndex(-1); }}
                                    style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee', backgroundColor: idx === selectedUrunIndex ? '#e3f2fd' : 'transparent', fontWeight: idx === selectedUrunIndex ? '600' : 'normal' }}>
                                    {urun.urun_adi}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <label style={{ fontWeight: '500' }}>Adet</label>
                <input type="number" value={aktifUrunAdet}
                    data-nav-id="alt-urun-adet-input"
                    onChange={e => setAktifUrunAdet(e.target.value ? parseInt(e.target.value) : '')}
                    onKeyDown={e => {
                        if (e.key === 'Enter') { e.preventDefault(); if (aktifUrun && aktifUrunAdet > 0) handleSepeteEkle(); }
                        else if (e.key === 'ArrowUp' && !e.altKey) { e.preventDefault(); navAlaninaGec('alt-urun-arama-input'); }
                    }}
                    style={{ width: '65px', height: '30px', background: 'white', textAlign: 'center', border: '1px solid #ccc', borderRadius: '4px', padding: '5px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }}
                />
                <button type="button" onClick={handleSepeteEkle}
                    style={{ height: '27px', background: '#F8F8F8', borderRadius: '8px', border: '0.50px solid black', cursor: 'pointer', padding: '0 12px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '5px', fontFamily: 'Poppins, sans-serif' }}>
                    <img src={PlusIcon} alt="Ekle" style={{ height: '12px' }} /> <span>Ürün Ekle</span>
                </button>
            </div>

            {/* SEPET TABLOSU */}
            <div style={{ marginTop: '15px' }}>
                <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ borderBottom: '2px solid #333' }}>
                            <th style={{ ...tableCellStyle, textAlign: 'left', fontWeight: '500' }}>Ürün Adı</th>
                            <th style={{ ...tableCellStyle, textAlign: 'center', fontWeight: '500', width: '120px' }}>Birim Fiyat</th>
                            <th style={{ ...tableCellStyle, textAlign: 'center', fontWeight: '500', width: '100px' }}>Adet</th>
                            <th style={{ ...tableCellStyle, textAlign: 'center', fontWeight: '500', width: '120px' }}>Toplam Fiyat</th>
                            <th style={{ ...tableCellStyle, textAlign: 'center', fontWeight: '500', width: '80px' }}>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sepet.length === 0 ? (
                            <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#888', fontFamily: 'Poppins, sans-serif' }}>Sepetiniz boş</td></tr>
                        ) : (
                            sepet.map((urun, index) => (
                                <tr key={`${urun.id}-${index}`}>
                                    <td style={tableCellStyle}>{urun.urun_adi}</td>
                                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                                        {editingCell?.index === index && editingCell?.field === 'fiyat' ? (
                                            <input type="number" value={urun.fiyat} autoFocus onBlur={() => setEditingCell(null)}
                                                onChange={e => handleSepetChange(index, 'fiyat', e.target.value)}
                                                style={{ width: '70px', height: '27px', background: 'white', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'center', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} />
                                        ) : (
                                            <>{(urun.fiyat || 0).toFixed(2)} ₺<span onClick={() => setEditingCell({ index, field: 'fiyat' })} style={{ marginLeft: '8px', cursor: 'pointer' }}><img src={EditIcon} alt="Edit" style={{ verticalAlign: 'middle', width: '16px', height: '16px' }} /></span></>
                                        )}
                                    </td>
                                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                                        {!urun.isMakine && editingCell?.index === index && editingCell?.field === 'adet' ? (
                                            <input type="number" value={urun.adet} autoFocus onBlur={() => setEditingCell(null)}
                                                onChange={e => handleSepetChange(index, 'adet', e.target.value)}
                                                style={{ width: '70px', height: '27px', background: 'white', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'center', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} />
                                        ) : (
                                            <>{urun.adet}{!urun.isMakine && <span onClick={() => setEditingCell({ index, field: 'adet' })} style={{ marginLeft: '8px', cursor: 'pointer' }}><img src={EditIcon} alt="Edit" style={{ verticalAlign: 'middle', width: '16px', height: '16px' }} /></span>}</>
                                        )}
                                    </td>
                                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>{((urun.fiyat || 0) * urun.adet).toFixed(2)} ₺</td>
                                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                                        {!urun.isMakine && <span onClick={() => handleSepetUrunSil(index)} style={{ cursor: 'pointer' }}><img src={DeleteIcon} alt="Sil" style={{ width: '16px', height: '16px' }} /></span>}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* GENEL TOPLAM */}
            <div style={{ display: 'flex', marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '5px' }}>
                <div style={{ flex: 1 }} />
                <div style={{ marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                    <div style={{ width: '300px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '2px solid #333', paddingTop: '10px' }}>
                            <strong style={{ fontSize: '18px' }}>Genel Toplam</strong>
                            <strong style={{ fontSize: '20px' }}>{genelToplam.toFixed(2)} TL</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '15px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button type="button" onClick={onClose} style={saveBtnStyle}>Vazgeç</button>
                <button type="button" onClick={handleKaydet} style={saveBtnStyle}>{editingData ? 'Güncelle' : 'Kaydet'}</button>
            </div>
        </div>
    );
}

/* ===========================
   ALT SIPARIS DETAY BANDI
   =========================== */
function AltSiparisDetay({ altSiparis, anaMusteri, odeme_yontemi, faturaStatuslari, faturaDurumuSorgula,
    onAltGuncelle, onYenile, pasif }) {
    const [proformaTel, setProformaTel] = useState(anaMusteri?.telefon_numarasi || '');

    const proformaData = {
        id: `alt-${altSiparis.id}`,
        isAltSiparis: true,
        musteri: {
            ad_soyad: altSiparis.nickname,
            telefon_numarasi: anaMusteri?.telefon_numarasi || '',
            adres: anaMusteri?.adres || '',
            il: anaMusteri?.il || '',
            ilce: anaMusteri?.ilce || ''
        },
        sepet: altSiparis.sepet || [],
        siparis_tarihi: new Date().toISOString(),
        kargo_ucreti: 0, kapida_odeme_ucreti: 0, indirim: 0, kdv_tutari: 0,
        toplam_bedel: altSiparis.toplam_bedel || 0,
        odeme_yontemi: odeme_yontemi,
        teklif_kaynagi: 'W'
    };

    const handleSendWhatsapp = async () => {
        const proformaNode = document.getElementById(`proforma-alt-${altSiparis.id}`);
        const tableNode = document.getElementById(`proforma-table-container-alt-${altSiparis.id}`);
        const tel = proformaTel.replace(/[^0-9]/g, '');
        if (!proformaNode || !tableNode) return alert('Önizleme alanı bulunamadı.');
        if (!tel) return alert('Gönderilecek telefon numarası boş.');
        const origH = proformaNode.style.height;
        const origOv = tableNode.style.overflowY;
        try {
            proformaNode.style.height = 'auto'; tableNode.style.overflowY = 'visible';
            const blob = await htmlToImage.toBlob(proformaNode, { pixelRatio: 3, backgroundColor: '#ffffff' });
            if (!blob) throw new Error('Görsel oluşturulamadı.');
            await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
            window.location.href = `whatsapp://send?phone=90${tel}`;
        } catch (err) {
            alert('Gönderme sırasında hata oluştu.');
        } finally {
            proformaNode.style.height = origH; tableNode.style.overflowY = origOv;
        }
    };

    const colStyle = { flex: 1, padding: '15px', border: '1px solid #E0E0E0', borderRadius: '8px', backgroundColor: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', gap: '15px' };
    const colTitle = { fontWeight: '600', fontSize: '13px', color: '#555', textTransform: 'uppercase', borderBottom: '1px solid #eee', paddingBottom: '8px' };
    const actionBtn = { ...rowBtnStyle, width: 'auto', height: '27px', padding: '0 14px', display: 'flex', alignItems: 'center', gap: '6px' };
    const faturaStatus = faturaStatuslari && altSiparis.parasut_fatura_id ? faturaStatuslari[altSiparis.parasut_fatura_id] : null;

    return (
        <div style={{ display: 'flex', gap: '15px', fontFamily: 'Poppins, sans-serif', padding: '10px', background: '#f8f8f8' }}>
            <div style={colStyle}>
                <h3 style={colTitle}>Proforma — {altSiparis.nickname}</h3>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                    <ProformaPreview detayData={proformaData} />
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        <button style={{ ...actionBtn, width: '110px' }} onClick={handleSendWhatsapp}>
                            <img src={WhatsappIcon} alt="WA" style={{ height: '14px' }} /> Gönder
                        </button>
                        <div>
                            <label style={{ fontSize: '12px', fontWeight: '500', display: 'block', marginBottom: '4px' }}>Gönderim Numarası</label>
                            <input type="text" value={proformaTel} onChange={e => setProformaTel(e.target.value)}
                                style={{ width: '100%', padding: '6px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', fontSize: '13px', fontFamily: 'Poppins, sans-serif' }} />
                        </div>
                    </div>
                </div>
            </div>
            <div style={colStyle}>
                <h3 style={{ ...colTitle, display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>Faturalama İşlemleri</span>
                    {faturaStatus?.iptal_edildi && (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '2px 10px', borderRadius: '12px', textTransform: 'none', whiteSpace: 'nowrap', border: '1px solid #842029', background: '#f8d7da', color: '#842029', fontSize: '12px', fontWeight: '600' }}>
                            <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#842029' }} />
                            Paraşüt'te İptal Edildi
                        </span>
                    )}
                </h3>
                <AltSiparisFaturalama altSiparis={altSiparis} faturaStatus={faturaStatus} faturaDurumuSorgula={faturaDurumuSorgula}
                    onAltGuncelle={onAltGuncelle} onYenile={onYenile} pasif={pasif} telefon={proformaTel} />
            </div>
        </div>
    );
}

/* ===========================
   TARIH SECIM MODALI
   =========================== */
function TarihSecModal({ onKaydet, onClose }) {
    const [tarih, setTarih] = useState(new Date().toISOString().split('T')[0]);
    return (
        <div style={{ padding: '20px', fontFamily: 'Poppins, sans-serif', width: '350px', background: '#F2F2F2', borderRadius: '8px' }}>
            <h3 style={{ margin: '0 0 15px', fontWeight: '500' }}>Sipariş Tarihi Seçin</h3>
            <input type="date" value={tarih} onChange={e => setTarih(e.target.value)}
                style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', marginBottom: '15px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} />
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                <button onClick={onClose} style={saveBtnStyle}>İptal</button>
                <button onClick={() => { onKaydet(tarih); onClose(); }} style={saveBtnStyle}>Onayla</button>
            </div>
        </div>
    );
}

/* ===========================
   ANA COMPONENT
   =========================== */
function CokluSiparis() {
    const [anaSimarisler, setAnaSimarisler] = useState([]);
    const [acikAnaId, setAcikAnaId] = useState(null);
    const [acikAltId, setAcikAltId] = useState(null);
    const [isAnaModalOpen, setIsAnaModalOpen] = useState(false);
    const [editingAnaId, setEditingAnaId] = useState(null);
    const [isAltModalOpen, setIsAltModalOpen] = useState(false);
    const [altModalAnaId, setAltModalAnaId] = useState(null);
    const [editingAltData, setEditingAltData] = useState(null);
    const [isTarihModalOpen, setIsTarihModalOpen] = useState(false);
    const [tarihModalAnaId, setTarihModalAnaId] = useState(null);
    const [faturaStatuslari, setFaturaStatuslari] = useState({});
    const [aramaTerimi, setAramaTerimi] = useState('');
    const [ayFiltresi, setAyFiltresi] = useState(() => { const now = new Date(); return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`; });
    const [kapidaOdemeUcreti, setKapidaOdemeUcreti] = useState(15);

    const userRole = (() => { try { const u = JSON.parse(localStorage.getItem('user')); return u?.rol || null; } catch { return null; } })();

    const API = process.env.REACT_APP_API_URL || '';
    const authHeaders = () => ({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` });

    useEffect(() => {
        fetch(`${API}/api/ayarlar`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } })
            .then(r => r.json())
            .then(data => { if (!data.hata) setKapidaOdemeUcreti(data.kapida_odeme_ucreti || 20); })
            .catch(() => {});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const fetchSiparisler = async (ay) => {
        try {
            const params = ay ? `?ay=${ay}` : '';
            const res = await fetch(`${API}/api/coklu-siparisler${params}`, { headers: authHeaders() });
            if (!res.ok) return;
            const data = await res.json();
            setAnaSimarisler(data);
        } catch { }
    };

    useEffect(() => { fetchSiparisler(ayFiltresi); }, [ayFiltresi]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleAnaKaydet = async (formData) => {
        try {
            const url = editingAnaId !== null
                ? `${API}/api/coklu-siparisler/${editingAnaId}`
                : `${API}/api/coklu-siparisler`;
            const method = editingAnaId !== null ? 'PUT' : 'POST';
            const res = await fetch(url, { method, headers: authHeaders(), body: JSON.stringify(formData) });
            const data = await res.json();
            if (!res.ok) throw new Error(data.hata || 'İşlem başarısız');
            if (editingAnaId !== null) {
                setAnaSimarisler(prev => prev.map(a => a.id === editingAnaId ? data : a));
            } else {
                setAnaSimarisler(prev => [data, ...prev]);
            }
        } catch (err) { alert(`Hata: ${err.message}`); }
        setEditingAnaId(null);
    };

    const handleAnaSil = async (id) => {
        if (!window.confirm('Bu ana siparişi ve tüm alt siparişleri silmek istediğinizden emin misiniz?')) return;
        try {
            await fetch(`${API}/api/coklu-siparisler/${id}`, { method: 'DELETE', headers: authHeaders() });
            setAnaSimarisler(prev => prev.filter(a => a.id !== id));
            if (acikAnaId === id) setAcikAnaId(null);
        } catch (err) { alert(`Hata: ${err.message}`); }
    };

    const handleAltKaydet = async (formData) => {
        const anaId = editingAltData ? editingAltData.anaId : altModalAnaId;
        try {
            let res;
            if (editingAltData) {
                res = await fetch(`${API}/api/coklu-siparisler/${anaId}/alt-siparisler/${editingAltData.altId}`,
                    { method: 'PUT', headers: authHeaders(), body: JSON.stringify(formData) });
            } else {
                res = await fetch(`${API}/api/coklu-siparisler/${anaId}/alt-siparisler`,
                    { method: 'POST', headers: authHeaders(), body: JSON.stringify(formData) });
            }
            const data = await res.json();
            if (!res.ok) throw new Error(data.hata || 'İşlem başarısız');
            setAnaSimarisler(prev => prev.map(a => a.id === anaId ? data : a));
        } catch (err) { alert(`Hata: ${err.message}`); }
        setEditingAltData(null); setAltModalAnaId(null);
    };

    const handleAltSil = async (anaId, altId) => {
        if (!window.confirm('Bu alt siparişi silmek istediğinizden emin misiniz?')) return;
        try {
            const res = await fetch(`${API}/api/coklu-siparisler/${anaId}/alt-siparisler/${altId}`,
                { method: 'DELETE', headers: authHeaders() });
            const data = await res.json();
            if (!res.ok) throw new Error(data.hata || 'Silme başarısız');
            setAnaSimarisler(prev => prev.map(a => a.id === anaId ? data : a));
            if (acikAltId === altId) setAcikAltId(null);
        } catch (err) { alert(`Hata: ${err.message}`); }
    };

    const handleGonder = async (anaId, tarih) => {
        const ana = anaSimarisler.find(a => a.id === anaId);
        if (!ana) return;
        if (!ana.musteri?.id) return alert('Ana siparişin müşteri kaydı bulunamadı. Lütfen müşteriyi kaydedin.');
        if (!ana.alt_siparisler || ana.alt_siparisler.length === 0) return alert('Göndermek için en az bir alt sipariş gereklidir.');
        const tumSepet = [];
        ana.alt_siparisler.forEach(alt => {
            (alt.sepet || []).forEach(urun => {
                const mevcut = tumSepet.findIndex(u => u.id === urun.id && u.fiyat === urun.fiyat);
                if (mevcut > -1) { tumSepet[mevcut].adet += urun.adet; } else { tumSepet.push({ ...urun }); }
            });
        });
        const araToplam = tumSepet.reduce((acc, u) => acc + (u.fiyat || 0) * (u.adet || 0), 0);
        const kapidaOdeme = ana.odeme_yontemi === 'K' ? kapidaOdemeUcreti : 0;
        const siparisData = {
            musteri: { id: ana.musteri.id },
            siparis: { siparis_kaynagi: ana.siparis_kaynagi, odeme_yontemi: ana.odeme_yontemi, kargo_ucreti: 0, kapida_odeme_ucreti: kapidaOdeme, indirim: 0, toplam_bedel: araToplam + kapidaOdeme, ara_toplam: araToplam, kdv_tutari: 0, siparis_tarihi: tarih },
            sepet: tumSepet.map(u => ({ id: u.id || null, urun_adi: u.urun_adi, adet: u.adet, fiyat: u.fiyat }))
        };
        try {
            const res = await fetch(`${API}/api/siparisler/yeni`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(siparisData) });
            const data = await res.json();
            if (!res.ok) throw new Error(data.hata || 'Sipariş oluşturulamadı');
            // Gönderildi olarak işaretle
            await fetch(`${API}/api/coklu-siparisler/${anaId}/gonderildi`, {
                method: 'PUT', headers: authHeaders(),
                body: JSON.stringify({ gonderilen_siparis_id: data.id || null })
            });
            setAnaSimarisler(prev => prev.map(a => a.id === anaId ? { ...a, gonderildi: true, gonderilen_siparis_id: data.siparis_no || data.id } : a));
            alert(`Sipariş başarıyla gönderildi!\nSipariş No: ${data.siparis_no || data.id}`);
        } catch (err) { alert(`Hata: ${err.message}`); }
    };

    // --- ALT SİPARİŞ FATURASI (işlemler AltSiparisFaturalama'da, Sipariş Listesi'ndeki akışla aynı) ---
    const faturaDurumuSorgula = async (faturaId) => {
        try {
            const res = await fetch(`${API}/api/faturalar/${faturaId}/durum`, { headers: authHeaders(), cache: 'no-cache' });
            const data = await res.json();
            if (res.ok) setFaturaStatuslari(prev => ({ ...prev, [faturaId]: { is_finalized: !!data.is_finalized, iptal_edildi: !!data.iptal_edildi } }));
        } catch { }
    };

    // Alt sipariş detayı açılınca faturasının resmileşip resmileşmediği sorgulanır
    useEffect(() => {
        if (acikAltId === null) return;
        const alt = anaSimarisler.flatMap(a => a.alt_siparisler || []).find(a => a.id === acikAltId);
        if (alt?.parasut_fatura_id) faturaDurumuSorgula(alt.parasut_fatura_id);
    }, [acikAltId]); // eslint-disable-line react-hooks/exhaustive-deps

    // Alt siparişin yerel kaydına alan yazar (ör. kaydedilen fatura bilgileri)
    const altGuncelle = (anaId, altId, alanlar) => setAnaSimarisler(prev => prev.map(a => a.id !== anaId ? a : {
        ...a, alt_siparisler: (a.alt_siparisler || []).map(alt => alt.id === altId ? { ...alt, ...alanlar } : alt)
    }));

    const hesaplaToplam = (ana) => {
        const altToplam = (ana.alt_siparisler || []).reduce((acc, alt) => acc + (alt.toplam_bedel || 0), 0);
        return altToplam + (ana.odeme_yontemi === 'K' ? kapidaOdemeUcreti : 0);
    };
    const filtreli = anaSimarisler.filter(a => {
        if (ayFiltresi) {
            const tarih = a.olusturma_tarihi ? a.olusturma_tarihi.substring(0, 7) : '';
            if (tarih !== ayFiltresi) return false;
        }
        if (!aramaTerimi) return true;
        const term = aramaTerimi.toLowerCase();
        return (a.musteri?.ad_soyad || '').toLowerCase().includes(term) || (a.musteri?.telefon_numarasi || '').includes(term);
    });
    const editingAna = editingAnaId !== null ? anaSimarisler.find(a => a.id === editingAnaId) : null;
    const altModalAna = altModalAnaId !== null ? anaSimarisler.find(a => a.id === altModalAnaId) : null;
    const editingAltAna = editingAltData ? anaSimarisler.find(a => a.id === editingAltData.anaId) : null;
    const editingAltSiparis = editingAltData ? editingAltAna?.alt_siparisler?.find(a => a.id === editingAltData.altId) : null;

    const badgeStyle = (bg) => ({ width: '22px', height: '22px', borderRadius: '50%', color: 'white', fontSize: '11px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: bg });

    return (
        <div style={{ background: '#F8F8F8', padding: '20px', borderRadius: '8px', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }}>
            <style>{`.coklu-ana-bant{transition:box-shadow .15s,transform .15s}.coklu-ana-bant:hover{transform:translateY(-1px);box-shadow:0 4px 10px rgba(0,0,0,.08);position:relative;z-index:5}.coklu-alt-row{transition:background .12s}.coklu-alt-row:hover{background:#e2e6ea!important}`}</style>

            {/* UST BAR */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexShrink: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <input type="month" value={ayFiltresi} onChange={e => setAyFiltresi(e.target.value)}
                        style={{ padding: '5px 8px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'Poppins, sans-serif', fontSize: '13px', height: '33px', boxSizing: 'border-box' }} />
                    <button onClick={() => { setEditingAnaId(null); setIsAnaModalOpen(true); }} disabled={userRole === 'depo_operatoru'}
                        style={{ ...rowBtnStyle, width: 'auto', height: '33px', padding: '0 15px', display: 'flex', alignItems: 'center', gap: '8px', opacity: userRole === 'depo_operatoru' ? 0.5 : 1, cursor: userRole === 'depo_operatoru' ? 'not-allowed' : 'pointer' }}>
                        <img src={PlusIcon} alt="+" style={{ height: '13px' }} /> Yeni Çoklu Sipariş
                    </button>
                    <input type="text" placeholder="Müşteri veya Tel No Ara..." value={aramaTerimi} onChange={e => setAramaTerimi(e.target.value)}
                        style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: '4px', width: '240px', fontFamily: 'Poppins, sans-serif', fontSize: '13px' }} />
                </div>
                <div style={{ fontSize: '13px', color: '#888' }}>{filtreli.length} / {anaSimarisler.length} sipariş</div>
            </div>

            {/* LISTE */}
            <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #E0E0E0', borderRadius: '5px', background: 'white', display: 'flex', flexDirection: 'column' }}>
                {/* BASLIK BANDI */}
                <div style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', background: '#E5E5E5', borderBottom: '1px solid #ddd', borderLeft: '4px solid transparent', flexShrink: 0, fontSize: '12px', fontWeight: '600', color: '#444' }}>
                    <span style={{ width: '28px', flexShrink: 0 }}>Sıra</span>
                    <span style={{ width: '105px', flexShrink: 0 }}>Telefon</span>
                    <span style={{ width: '160px', flexShrink: 0 }}>Ad Soyad</span>
                    <span style={{ flex: 1 }}>Adres</span>
                    <span style={{ width: '90px', flexShrink: 0, textAlign: 'center' }}>İlçe</span>
                    <span style={{ width: '90px', flexShrink: 0, textAlign: 'center', paddingRight: '8px' }}>İl</span>
                    <span style={{ width: '130px', flexShrink: 0, textAlign: 'center' }}>Tutar</span>
                    <span style={{ width: '110px', flexShrink: 0, marginLeft: '15px', textAlign: 'center' }}>Durum</span>
                    <span style={{ width: '140px', flexShrink: 0, marginLeft: '15px', textAlign: 'center' }}>İşlemler</span>
                </div>
                <div style={{ flex: 1, overflowY: 'auto' }}>
                {filtreli.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontSize: '14px' }}>Henüz çoklu sipariş oluşturulmamış.</div>
                ) : (
                    filtreli.map((ana, anaIdx) => {
                        const toplam = hesaplaToplam(ana);
                        const isOpen = acikAnaId === ana.id;
                        return (
                            <div key={ana.id} style={{ borderBottom: '1px solid #eee' }}>
                                <div className="coklu-ana-bant"
                                    style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', background: ana.gonderildi ? '#f0fff4' : isOpen ? '#e8ecf0' : 'white', cursor: 'pointer', borderLeft: ana.gonderildi ? '4px solid #28a745' : isOpen ? '4px solid #272935' : '4px solid transparent' }}
                                    onClick={() => setAcikAnaId(isOpen ? null : ana.id)}>
                                    <span style={{ width: '28px', color: '#aaa', fontSize: '12px', flexShrink: 0 }}>{anaIdx + 1}</span>
                                    <div style={{ width: '105px', flexShrink: 0, fontSize: '12px', color: '#444' }}>{ana.musteri?.telefon_numarasi || '—'}</div>
                                    <div style={{ width: '160px', flexShrink: 0 }}>
                                        <span style={{ fontSize: '13px' }}>{ana.musteri?.ad_soyad || 'İsimsiz'}</span>
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0, fontSize: '12px', color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ana.musteri?.adres || ''}</div>
                                    <div style={{ width: '90px', flexShrink: 0, fontSize: '12px', color: '#555', textAlign: 'center' }}>{ana.musteri?.ilce || ''}</div>
                                    <div style={{ width: '90px', flexShrink: 0, fontSize: '12px', color: '#555', textAlign: 'center', paddingRight: '8px' }}>{ana.musteri?.il || ''}</div>
                                    <div style={{ width: '130px', flexShrink: 0, textAlign: 'center', fontSize: '13px' }}>{toplam.toFixed(2)} ₺</div>
                                    <div style={{ width: '110px', display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center', marginLeft: '15px', flexShrink: 0 }}>
                                        <span style={badgeStyle(kaynakRenkleri[ana.siparis_kaynagi] || '#aaa')}>{ana.siparis_kaynagi}</span>
                                        <span style={badgeStyle(odemeRenkleri[ana.odeme_yontemi] || '#aaa')}>{ana.odeme_yontemi}</span>
                                        <span title="Makine Baskısı" style={{ ...badgeStyle(ana.has_makine_baskisi ? '#93D82F' : '#F4885A') }}><img src={ana.has_makine_baskisi ? TickIcon : CrossIcon} alt="Makine" style={{ height: '12px', width: '12px' }} /></span>
                                        <span title="Özel Baskı" style={{ ...badgeStyle(ana.has_ozel_baskisi ? '#93D82F' : '#F4885A') }}><img src={ana.has_ozel_baskisi ? TickIcon : CrossIcon} alt="Özel" style={{ height: '12px', width: '12px' }} /></span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '2px', marginLeft: '15px', flexShrink: 0, width: '140px', justifyContent: 'center', alignItems: 'center' }} onClick={e => e.stopPropagation()}>
                                        <button title="Alt Sipariş Ekle" onClick={() => { setAltModalAnaId(ana.id); setEditingAltData(null); setIsAltModalOpen(true); }} disabled={userRole === 'depo_operatoru'}
                                            style={{ background: 'none', border: 'none', cursor: userRole === 'depo_operatoru' ? 'not-allowed' : 'pointer', padding: '4px', opacity: userRole === 'depo_operatoru' ? 0.35 : 1, display: 'flex', alignItems: 'center' }}>
                                            <svg viewBox="0 0 24 24" fill="none" stroke="#3783c2" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="15" height="15"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="13" y2="17"/><path d="M19.5 3l.35 1.05 1.05.35-1.05.35-.35 1.05-.35-1.05-1.05-.35 1.05-.35z" fill="#3783c2" stroke="none"/></svg>
                                        </button>
                                        <button title="Düzenle" onClick={() => { setEditingAnaId(ana.id); setIsAnaModalOpen(true); }}
                                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center' }}>
                                            <img src={EditIcon} alt="Düzenle" style={{ width: '15px', height: '15px' }} />
                                        </button>
                                        <button title="Sil" onClick={() => handleAnaSil(ana.id)}
                                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center' }}>
                                            <img src={DeleteIcon} alt="Sil" style={{ width: '16px', height: '16px' }} />
                                        </button>
                                        <button title="Gönder" onClick={() => { setTarihModalAnaId(ana.id); setIsTarihModalOpen(true); }} disabled={userRole === 'depo_operatoru' || !ana.alt_siparisler?.length}
                                            style={{ background: 'none', border: 'none', cursor: (userRole === 'depo_operatoru' || !ana.alt_siparisler?.length) ? 'not-allowed' : 'pointer', padding: '4px', opacity: (userRole === 'depo_operatoru' || !ana.alt_siparisler?.length) ? 0.35 : 1, display: 'flex', alignItems: 'center' }}>
                                            <svg viewBox="0 0 512 512" fill="#28a745" width="15" height="15"><path d="M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 72.59v113.29a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 303.45A24 24 0 0016 327v113.31A23.57 23.57 0 0026.59 460a23.94 23.94 0 0013.22 4 24.55 24.55 0 009.52-1.93L476.4 285.92a24.13 24.13 0 000-58.87z"/></svg>
                                        </button>
                                    </div>
                                </div>

                                {isOpen && (
                                    <div style={{ background: 'white', padding: '0 16px 12px 16px' }}>
                                        {(!ana.alt_siparisler || ana.alt_siparisler.length === 0) ? (
                                            <div style={{ textAlign: 'center', padding: '20px', color: '#888', fontSize: '13px' }}>Henüz alt sipariş eklenmemiş. Sağdaki "+Alt Sipariş" butonunu kullanın.</div>
                                        ) : (
                                            ana.alt_siparisler.map((alt, altIdx) => {
                                                const isAltOpen = acikAltId === alt.id;
                                                return (
                                                    <div key={alt.id} style={{ marginTop: '8px', border: '1px solid #ddd', borderRadius: '6px', background: 'white', overflow: 'hidden' }}>
                                                        <div className="coklu-alt-row"
                                                            style={{ display: 'flex', alignItems: 'center', padding: '10px 14px', cursor: 'pointer', background: isAltOpen ? '#dde3ea' : '#edf0f3' }}
                                                            onClick={() => setAcikAltId(isAltOpen ? null : alt.id)}>
                                                            <span style={{ width: '22px', fontSize: '11px', color: '#aaa' }}>{altIdx + 1}</span>
                                                            <div style={{ flex: 1 }}>
                                                                <span style={{ fontSize: '13px' }}>{alt.nickname}</span>
                                                                {alt.parasut_fatura_id && <span style={{ marginLeft: '8px', fontSize: '11px', background: '#e3f2fd', color: '#1565c0', padding: '1px 6px', borderRadius: '10px' }}>Faturalı</span>}
                                                            </div>
                                                            <div style={{ fontSize: '13px', marginRight: '15px' }}>{(alt.toplam_bedel || 0).toFixed(2)} ₺</div>
                                                            <div style={{ display: 'flex', gap: '6px' }} onClick={e => e.stopPropagation()}>
                                                                <button onClick={() => { setAltModalAnaId(ana.id); setEditingAltData({ anaId: ana.id, altId: alt.id }); setIsAltModalOpen(true); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '3px' }}>
                                                                    <img src={EditIcon} alt="Edit" style={{ width: '14px' }} />
                                                                </button>
                                                                <button onClick={() => handleAltSil(ana.id, alt.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '3px' }}>
                                                                    <img src={DeleteIcon} alt="Sil" style={{ width: '15px' }} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {isAltOpen && (
                                                            <div style={{ borderTop: '1px solid #eee' }}>
                                                                <AltSiparisDetay altSiparis={alt} anaMusteri={ana.musteri} odeme_yontemi={ana.odeme_yontemi}
                                                                    faturaStatuslari={faturaStatuslari} faturaDurumuSorgula={faturaDurumuSorgula}
                                                                    onAltGuncelle={(alanlar) => altGuncelle(ana.id, alt.id, alanlar)}
                                                                    onYenile={() => fetchSiparisler(ayFiltresi)}
                                                                    pasif={userRole === 'depo_operatoru'} />
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
                </div>
            </div>

            <Modal isOpen={isAnaModalOpen} onClose={() => { setIsAnaModalOpen(false); setEditingAnaId(null); }}>
                <AnaSimarisModal editingData={editingAna} onClose={() => { setIsAnaModalOpen(false); setEditingAnaId(null); }} onKaydet={handleAnaKaydet} />
            </Modal>
            <Modal isOpen={isAltModalOpen} onClose={() => { setIsAltModalOpen(false); setAltModalAnaId(null); setEditingAltData(null); }}>
                <AltSiparisModal anaMusteri={editingAltData ? editingAltAna?.musteri : altModalAna?.musteri} editingData={editingAltSiparis}
                    onClose={() => { setIsAltModalOpen(false); setAltModalAnaId(null); setEditingAltData(null); }} onKaydet={handleAltKaydet} />
            </Modal>
            <Modal isOpen={isTarihModalOpen} onClose={() => { setIsTarihModalOpen(false); setTarihModalAnaId(null); }} minWidth="auto">
                <TarihSecModal onClose={() => { setIsTarihModalOpen(false); setTarihModalAnaId(null); }} onKaydet={(tarih) => { if (tarihModalAnaId) handleGonder(tarihModalAnaId, tarih); }} />
            </Modal>
        </div>
    );
}

export default CokluSiparis;
